<h2 class="mt-4">{{cardConfiguration.title}}</h2>

<!-- Booleans in VM are being considered string @ runtime, boolean validationsn need to be changed once they are the proper type @ runtime-->
<fieldset [disabled]="isWorkflowOnSubscriber">
<div class="row">  
    <div class="col-sm-5">
      <div class="form-group">
        <label for="MandatoryService"><span class="mandatory">*</span>{{'CardMilitaryInformation.MandatoryService' | translate}}</label>
        <div class="btn-group btn-group-toggle" >
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hadMandatoryService" [radioLabel]="hadMandatoryService">
            <input type="radio" [(ngModel)]="cardData.hadMandatoryService" name="hadMandatoryService" #hadMandatoryService="ngModel" [value]="domain.value" required
                   [clearRelated]="{model : this.cardData , propsToReset : ['lostPublicLink']} ">
            {{domain.description}}
          </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-5">
      <div class="form-group">
        
          <label for="LostPublicLink" [class.disabled]="!cardData.hadMandatoryService || cardData.hadMandatoryService?.toString() == 'false'">
              <span class="mandatory" *ngIf="cardData.hadMandatoryService?.toString() == 'true'">*</span>{{'CardMilitaryInformation.LostPublicLink' | translate}}
              <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardMilitaryInformation.LostPublicLink' | translate}}"></span>
          </label>
          <fieldset [disabled]="!cardData.hadMandatoryService || cardData.hadMandatoryService?.toString() == 'false'">
            <div class="btn-group btn-group-toggle" style="width:100%;">
              <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.lostPublicLink" [radioLabel]="lostPublicLink">
                <input type="radio" [(ngModel)]="cardData.lostPublicLink" name="lostPublicLink" [value]="domain.value" #lostPublicLink="ngModel"
                       [required]="cardData.hadMandatoryService?.toString() == 'true'">
                {{domain.description}}
              </label>
              <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
            </div>
          </fieldset>
      </div>
    </div>
  </div>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->


